import React from 'react';
import styled, { useTheme } from 'styled-components';
import { motion } from 'framer-motion';
import { BsArrowDown } from 'react-icons/bs';

const ScrollButton = styled(motion.button)`
  background: ${props => `linear-gradient(135deg, ${props.theme.colors.background}ee 0%, ${props.theme.colors.background}dd 100%)`};
  backdrop-filter: blur(20px);
  border: 1px solid ${props => props.theme.colors.border}40;
  border-radius: 50%;
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 8px 32px rgba(0,0,0,0.12), 0 4px 16px rgba(0,0,0,0.08);
  color: ${props => props.theme.colors.primary};
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  opacity: ${props => props.isVisible ? 1 : 0};
  pointer-events: ${props => props.isVisible ? 'auto' : 'none'};
  transform: ${props => props.isVisible ? 'translateY(0) scale(1)' : 'translateY(20px) scale(0.8)'};
  position: relative;
  
  /* Simple glassmorphism without pseudo-elements */
  background-image: 
    linear-gradient(135deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.05) 100%),
    ${props => `linear-gradient(135deg, ${props.theme.colors.primary}40 0%, ${props.theme.colors.primary}20 100%)`};
  background-size: 100% 100%, 104% 104%;
  background-position: center, center;
  animation: scrollButtonPulse 2s ease-in-out infinite;
  
  @keyframes scrollButtonPulse {
    0%, 100% { 
      background-size: 100% 100%, 104% 104%;
      box-shadow: ${props => `0 4px 20px ${props.theme.colors.primary}25`};
    }
    50% { 
      background-size: 100% 100%, 108% 108%;
      box-shadow: ${props => `0 6px 30px ${props.theme.colors.primary}35`};
    }
  }

  &:hover {
    background: ${props => `linear-gradient(135deg, ${props.theme.colors.primary}15 0%, ${props.theme.colors.primary}08 100%)`};
    transform: translateY(-2px) scale(1.05);
    box-shadow: 0 12px 40px rgba(0,0,0,0.18), 0 6px 20px rgba(0,0,0,0.12);
    border-color: ${props => props.theme.colors.primary}60;
  }
  
  &:active {
    transform: translateY(0) scale(0.98);
  }

  svg {
    width: 22px;
    height: 22px;
    transition: all 0.2s ease;
    position: relative;
    z-index: 1;
    filter: drop-shadow(0 1px 2px rgba(0,0,0,0.1));
  }
  
  &:hover svg {
    transform: translateY(1px);
  }
`;

function ScrollToBottom({ isVisible, onClick }) {
  const theme = useTheme();
  
  return (
    <ScrollButton
      theme={theme}
      isVisible={isVisible}
      onClick={onClick}
      whileHover={{ scale: 1.05, y: -2 }}
      whileTap={{ scale: 0.95, y: 0 }}
      initial={{ opacity: 0, y: 20, scale: 0.8 }}
      animate={{ 
        opacity: isVisible ? 1 : 0, 
        y: isVisible ? 0 : 20, 
        scale: isVisible ? 1 : 0.8 
      }}
      transition={{ 
        type: "spring", 
        stiffness: 400, 
        damping: 25 
      }}
    >
      <BsArrowDown />
    </ScrollButton>
  );
}

export default ScrollToBottom;